export default "__VITE_ASSET__5V33J0iS__"